import { FormlyFieldConfig } from '@ngx-formly/core';
import { LuTypeaheadOptions, LuTypeaheadUrlOptions } from 'lu-typeahead';
import { Subject } from 'rxjs';
import { LuFormlyBuilder } from '../formly.builder';
import { FieldType } from './formly-builder.models';

export class LuFormlyTypeaheadBuilder extends LuFormlyBuilder {
	protected type = FieldType.TYPEAHEAD;
	private options: LuTypeaheadOptions;
	private urlOptions: LuTypeaheadUrlOptions;
	private initialItems: any;
	/**
	 * Used for setting internal typeahead state (internal selected values)
	 * So that we can add data to dynamic typeaheads with set selectAs property
	 * We inject whole objects, compare to model data approach that will inject selectAs property and wont display label
	 * Needed for: Sticky filters, Control bar view switching...
	 */ private internalSelection: any[];

	public setOptions(options: LuTypeaheadOptions): this {
		this.options = options;
		return this;
	}

	public setUrlOptions(urlOptions: LuTypeaheadUrlOptions): this {
		this.urlOptions = urlOptions;
		return this;
	}

	public setInitialItems(initialItems: any): this {
		this.initialItems = initialItems;
		return this;
	}

	public build(): FormlyFieldConfig {
		if (this.options == null || this.initialItems == null) {
			console.error('=== Field Typeahead may not build correctly ===');

			if (this.options == null) {
				console.error('Options are null or undefined');
			}

			if (this.initialItems == null) {
				console.error('InitialItems are null or undefined');
			}

			console.error(this);
			return;
		}
		const field = super.build();

		field.templateOptions.luAdminTypeaheadOptions = this.options;
		field.templateOptions.luInitialItems = this.initialItems;

		// Logic for getting and setting typeahead internal selection variable
		field.templateOptions.internalSelectionChange = new Subject<any[]>();
		field.templateOptions.internalSelection = this.internalSelection;
		field.templateOptions.internalSelectionChange$ = field.templateOptions.internalSelectionChange.asObservable();
		field.templateOptions.dropdownStateChange$ = new Subject<boolean>();

		if (this.urlOptions !== null) {
			field.templateOptions.luAdminTypeaheadRouteParams = this.urlOptions;
		}

		if (this.readonly) {
			field.templateOptions.luAdminTypeaheadOptions.readonly = this.readonly;
		}

		if (this.disabled) {
			field.templateOptions.luAdminTypeaheadOptions.disabled = this.disabled;
		}

		return field;
	}
}
